import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-lightbox-modal',
  templateUrl: './lightbox-modal.component.html',
  styleUrls: ['./lightbox-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class LightboxModalComponent implements OnInit {

  @Input() imgURL: string;

  constructor(private modalController: ModalController) { }

  ngOnInit() { }

  async close() {
    await this.modalController.dismiss();
  }
}
